import React from "react";
import { useReveal } from "../hooks/useReveal";

export const About = (props) => {
  const [imgRef, imgVisible] = useReveal();
  const [textRef, textVisible] = useReveal();
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div
            ref={imgRef}
            className={`col-xs-12 col-md-6 reveal ${imgVisible ? "is-visible" : ""}`}
          >
            {" "}
            <img src="img/about.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div
            ref={textRef}
            className={`col-xs-12 col-md-6 reveal reveal-delay-1 ${textVisible ? "is-visible" : ""}`}
          >
            <div className="about-text">
              <h2>About Us</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>Why Choose Us?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
